import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { QueryProvider } from '@shared/queries/query-provider';
import { select, Store } from '@ngrx/store';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { filter, take, takeUntil } from 'rxjs/operators';
import { getQueryResponse } from '@shared/store/selectors/query.selector';
import { of, Subject } from 'rxjs';
import { BreadcrumbModel } from '@shared/models/breadcrumb.model';
import { ActivatedRoute, Router } from '@angular/router';
import * as pbi from 'powerbi-client';
import { FilterType, Permissions, TokenType, ViewMode } from 'powerbi-models';
import { getEntityStatus, } from '../store/selector/power-search.selector';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { getCurrentProject, ProjectState, } from '../../projects/store/reducers/projects.reducer';
import { IPowerSearchState } from '../store/reducer/power-search.reducer';
import { ResetVisualizerDataCommand, } from '@shared/commands/dashboard.command';
import { VisualizerNotificationService } from '../Services/visualizer-notification.service';
import { SecurityState } from '@shared/store/reducers/security.reducer';
import { getFeaturesInfo, getUserInfo, hasFeature } from '@shared/store/selectors/security.selector';
import { AnalyticsService } from '@core/services/analytics.service';
import { resetAnalyticsError, resetAnalyticsStatus, resetAnalyticsSuccess } from '../store/selector/dashboard-selector';
import { IDashboardState } from '../store/reducer/dashboard-reducer';
import { ResetAnalyticsReport, ResetAnalyticsReportError, ResetAnalyticsReportSuccess } from '../store/action/dashboard-actions';
import { DashboardService } from '@core/services/dashboard.service';
import { PlatformCommand } from '@shared/commands/command-base';
import { CommandService } from '@core/services/command.service';
import { DialogService } from '@shared/services/dialog-service';
import { models } from 'powerbi-client';
import { FETCH_ALL_STREAMS } from '@features/footprint/transaction/store/actions/transaction.actions';
import { PlatformQuery } from '@shared/models/platform-query/platform-query';
import { PlatformQueryService } from '@core/services/platform-query.service';
import { Observable } from "rxjs";
import { Api } from '@shared/constants/common-field.constants';

@Component({
    standalone: false,
    selector: 'particle-power-search-contentv2',
  templateUrl: './power-search-contentv2.component.html',
  styleUrls: ['./power-search-contentv2.component.scss'],
})
export class PowerSearchContentv2Component
  implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('report', { read: ElementRef }) container: ElementRef;
  breadCrumbsKey = 'breadCrumbsForPowerSearch';
  private reportType = 'Analytic';
  pageDictionary = {
    "entities": "Entity Rates And Entity Attributes",
    "transactions": "Transactions"
  }
  breadcrumbs$: any;
  ngUnsubscribe$: Subject<void>;
  breadcrumbs: BreadcrumbModel[];
  selectedIndex: any;
  tabs: any;
  tabConfig: any;
  failureResponse$: any;
  loadingPercentage: any = {};
  dataLoaded: any;
  reportTypeFromQuery: any;
  failureResponse: boolean;
  private groupId: any;
  header: any;
  icon: string;
  private powerQuery: string;
  private tabConfig$: Subject<any>;
  private reportConfig: any;
  report: any;
  reportsContainer: any;
  reportFilters = [];
  powerbi: any;
  tabId: string;
  public tabGroup: any;
  private projectId: string;
  private pageName: string;
  hasEntity: boolean;
  private features: {};
  private demo: boolean;
  private isEditable: boolean;
  isDefaultReport = false;
  errorInit = false;
  intervalTimer: any;
  private powerbiReportConfig: any;
  alertInfoId: string;
  user: any;
  hasFeature$: Observable<any>;
  constructor(
    private queryStore: Store<IQueryState>,
    private router: Router,
    private dashboardService: DashboardService,
    private activatedRoute: ActivatedRoute,
    private fuseSplashScreenService: FuseSplashScreenService,
    private projectStore: Store<ProjectState>,
    private powerSearchStore: Store<IPowerSearchState>,
    private visualizerNotificationService: VisualizerNotificationService,
    private securityStore: Store<SecurityState>,
    private analyticsService: AnalyticsService,
    private dashboardStore: Store<IDashboardState>,
    protected commandService: CommandService,
    protected platformQueryService: PlatformQueryService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.ngUnsubscribe$ = new Subject<void>();
    this.demo = false;
    this.dataLoaded = false;
    this.failureResponse = false;
    this.fuseSplashScreenService.show();
    this.tabConfig$ = new Subject<void>();
    this.icon = 'far fa-home';
    this.selectedIndex = 0;
    this.alertInfoId = '';
    this.queryStore
      .pipe(select(getQueryResponse, 'MyDemo'))
      .subscribe((state) => {
        if (state) {
          this.demo = true;
        } else {
          this.demo = false;
        }
      });
    this.projectStore
      .pipe(
        select(getCurrentProject),
        filter((val) => val != null && val !== undefined),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((response) => {
        this.projectId = response.ProjectId;
      });
    this.securityStore
      .pipe(select(getFeaturesInfo), takeUntil(this.ngUnsubscribe$))
      .subscribe((state) => {
        this.features = state;
      });

    this.securityStore
      .pipe(select(getUserInfo), takeUntil(this.ngUnsubscribe$))
      .subscribe((state) => {
        this.user = state;
      });
    this.handleResetReport();
    this.powerSearchStore
      .pipe(
        select(getEntityStatus),
        takeUntil(this.ngUnsubscribe$),
        filter((val) => val != null && val !== undefined)
      )
      .subscribe((response) => {
        this.hasEntity = response;
      });
    this.setBreadCrumb();
    this.getTabConfig();



    if (window.sessionStorage.getItem('alertInfoId')) {
      this.alertInfoId = window.sessionStorage.getItem('alertInfoId');
    }

    this.activatedRoute.params
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((params) => {

        this.powerQuery = null;
        this.pageName = null;
        this.groupId = params['groupId'];
        this.tabId = params['tabId'];
        this.setTabGroup();
        this.selectedIndex = this.getSelectedIndex(this.tabId);
        this.setQuery();
        this.setPageName();
        this.breadcrumbs$
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe((state) => {
            if (state && !state.errors) {
              this.breadcrumbs[1].children = state.children;
              const breadCrumbForCurrentRoute = this.getBreadCrumbForCurrentRoute(
                this.groupId,
                this.breadcrumbs
              );
              this.setActiveBreadcrumb(breadCrumbForCurrentRoute);
            }
          });
        this.displayReport();
      });
  }

  private getTabConfig() {
    this.dashboardService.getPowerSearchTabsConfig().subscribe((response) => {
      this.tabConfig = response;
      this.setTabGroup();
      this.selectedIndex = this.getSelectedIndex(this.tabId);
      this.setQuery();
      this.setPageName();
      this.displayReport();
    });
  }

  private setBreadCrumb() {
    this.header = {
      displayText: 'Power Search',
      relativeUrl: 'home',
    };
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'home',
        title: 'Home',
        type: 'home',
        relativeUrl: 'home',
        children: [],
      },
      <BreadcrumbModel>{
        id: 'entities',
        title: 'Entities',
        type: 'DropDown',
        relativeUrl: 'home/entities/rates',
        children: [],
      },
    ];
    QueryProvider.invokeQuery(this.queryStore, this.breadCrumbsKey, {});
    this.breadcrumbs$ = this.queryStore.pipe(
      select(getQueryResponse, this.breadCrumbsKey)
    );
  }

  setActiveBreadcrumb(breadCrumb: BreadcrumbModel) {
    if (breadCrumb) {
      this.breadcrumbs[1].id = breadCrumb.id;
      this.breadcrumbs[1].title = breadCrumb.title;
      this.breadcrumbs[1].type = breadCrumb.type;
      this.breadcrumbs[1].relativeUrl = breadCrumb.relativeUrl;
    }
  }
  ngOnDestroy(): void {
    // this.visualizerNotificationService.destroyPulling();
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  breadCrumbSelectionChange($event: BreadcrumbModel) {
    const id: string = `${$event.id}`;
    this.hasFeature$ = this.securityStore.pipe(select(hasFeature));
    this.hasFeature$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(feature => {
      switch (id) {
        case 'due-dates':
          if (feature('DDT')) {
            this.getAnalyticReportToolLinkCommand();
          } else {
            this.router.navigateByUrl(`/promotion/ddt`);
          }
          break;
        case 'entities':
          this.getEntitiesAndTransactionsAnalyticReportToolLinkCommand("entities");
          break;
        case 'transactions':
          this.getEntitiesAndTransactionsAnalyticReportToolLinkCommand("transactions");
          break;
        default:
          this.router.navigateByUrl($event.relativeUrl);
          break;
      }
    });

  }

  onSelectedTabChanged($event: number) {
    this.selectedIndex = $event;
    this.setQuery();
    this.router.navigateByUrl(
      `/home/${this.tabGroup.groupId}/${this.tabGroup.tabs[this.selectedIndex].id
      }`
    );
  }
  displayReport(resetReport = false) {
    if (!this.reportConfig || !this.pageName) { return; }
    this.fuseSplashScreenService.hide();
    if (this.report && !resetReport) {
      this.goToPage(this.pageName);
    } else {
      this.powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      if (!this.reportsContainer) {
        this.reportsContainer = document.getElementById('reportsContainer');
      }
      if (this.reportsContainer) {
        this.powerbi.reset(this.reportsContainer);
        this.report = this.powerbi.embed(
          this.reportsContainer,
          this.reportConfig
        );


        setTimeout(() => {
          this.report.on('loaded', (event) => {
            if (this.pageName) {
              this.goToPage(this.pageName);
            }
            // if(this.alertInfoId !== ''){
            //   this.setAlertFilter();
            // }
            this.setAllFilter();
          });
        }, 50)
      }
    }
  }
  setAllFilter() {
    let filters = [];
    if (!this.isDefaultReport) {
      this.addProjectFilter(filters);
    }
    if (this.report && this.report.iframe && this.report.iframe.contentWindow) {
      if (this.reportFilters && this.reportFilters.length > 0) {
        this.setReportFilters(filters);
      }
      if (this.alertInfoId !== '') {
        this.setAlertFilterWithExistingFilters(filters);
      } else {
        this.removeAllFilters();
        this.report.setFilters(filters);
      }
    }
  }
  setReportFilters(existingFilters) {
    this.reportFilters.forEach(filter => {
      existingFilters.push(filter);
    });
  }
  removeAllFilters() {
    this.report.getPages().then((pages) =>
      pages.forEach((page) => {
        page.removeFilters();
      })
    );
  }

  private addProjectFilter(filters) {
    //if (this.report && this.report.iframe && this.report.iframe.contentWindow) {
    let tableNames = ['Entities', 'EntityChart', 'Transactions', 'TreatyFootprint']
    console.log('Adding Project Filter');
    tableNames.forEach(tableName => {
      let filter = {
        $schema: 'http://powerbi.com/product/schema#basic',
        target: {
          table: tableName,
          column: 'ProjectId',
        },
        operator: 'In',
        values: [`${this.projectId}`],
        filterType: FilterType.Basic,
      };
      // this.report.getPages().then((pages) =>
      //   pages.forEach((page) => {
      //     page.removeFilters();
      //   })
      // );
      // const filters = [{...filter}];
      // console.log("Project Filters are Added");
      // this.report.setFilters(filters);
      filters.push(filter);
    });

    // }
  }


  // private testFilter(filters){
  //   this.report.getPages().then((pages) =>
  //       pages.forEach((page) => {
  //         if (page.displayName === this.pageName) {
  //           page.getVisuals().then((visuals) => {
  //             visuals.forEach(visual => {
  //               if(visual.title === 'Hierarchy Slicer'){
  //                 // visual.getSlicerState().then(res => {
  //                 //   console.log(res);
  //                 // });
  //                 // visual.setSlicerState({
  //                 //   filters: [basicFilter]
  //                 // }).then(res => {
  //                 //   visual.getSlicerState().then(res1 => {
  //                 //     console.log(res1);
  //                 //   });
  //                 // });
  //              }
  //             });
  //           });
  //         }
  //       })
  //     );
  // }


  private setAlertFilterWithExistingFilters(filters) {
    if (this.report && this.report.iframe && this.report.iframe.contentWindow) {
      console.log('Set Alert Filter');

      let alertQuery = new PlatformQuery();
      alertQuery.api = "ChangeReportApi";
      alertQuery.name = "AlertInfoQuery"
      alertQuery.setValue("AlertInfoId", this.alertInfoId);

      this.platformQueryService.executeQuery(alertQuery).pipe(take(1)).subscribe(res => {
        if (res && res.fieldValues['alertInfoCountries']) {
          let alertCountries = res.fieldValues['alertInfoCountries'];
          // let alertFilters = [];
          // alertFilters.push(this.getCountryFilter(alertCountries));

          filters.push(this.getCountryFilter(alertCountries));
          //console.log(alertFilters);
          //this.af=JSON.stringify(alertFilters);
          //this.report.updateFilters(models.FiltersOperations.Add, alertFilters);
          this.removeAllFilters();
          this.report.setFilters(filters);
          console.log("AlertFilters Are Added");
          //setTimeout(()=>{this.ref.detectChanges();}, 70);
        }
      });
    }
  }
  private getCountryFilter(countries) {
    let filter = {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Entities",
        column: "CountryName"
      },
      values: [],
      operator: "In",
      filterType: FilterType.Basic
    };
    countries.forEach(country => {
      filter.values.push(country);
    });
    return filter;
  }

  private getBreadCrumbForCurrentRoute(
    groupId: string,
    breadcrumbs: BreadcrumbModel[]
  ) {
    let result = null;
    breadcrumbs[1].children.forEach((breadCrumb) => {
      if (breadCrumb.id === groupId) {
        result = breadCrumb;
      }
    });
    return result;
  }

  private getSelectedIndex(tabId: string) {
    if (!this.tabGroup || !this.tabId) { return; }
    for (let index = 0; index < this.tabGroup.tabs.length; index++) {
      if (this.tabGroup.tabs[index].id === tabId) {
        return index;
      }
    }
    return 0;
  }
  private setQuery() {
    if (!this.tabGroup) { return; }
    this.powerQuery = this.tabGroup.tabs[this.selectedIndex].powerQuery;
  }

  ngAfterViewInit(): void {
    if (this.container) {
      this.reportsContainer = this.container.nativeElement;
    }
  }
  setConfig(payload) {
    let config = <pbi.IEmbedConfiguration>{
      type: 'report',
      tokenType: TokenType.Embed,
      viewMode: ViewMode.View,
      permissions: Permissions.All,
      uniqueId: payload.reportId,
      embedUrl:
        'https://app.powerbi.com/reportEmbed?reportId=' +
        payload.reportId +
        '&groupId=' +
        payload.workspaceId,
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
      },
      accessToken: payload.token,
    };
    this.reportConfig = config;
    this.powerbiReportConfig = payload;
  }

  private setTabGroup() {
    if (!this.groupId || !this.tabConfig) {
      return;
    }
    this.tabConfig.tabGroups.forEach((tabGroup) => {
      if (tabGroup.groupId === this.groupId) {
        this.tabGroup = tabGroup;
      }
    });
  }

  private setPageName() {
    if (this.tabConfig) {
      if (!this.demo) {
        if (this.isFeatureEnabled(this.tabId)) {
          this.pageName = this.tabGroup.tabs[this.selectedIndex].pageName;
        } else {
          console.log('Feature Not found for Tab : ', this.tabId);
          this.pageName = this.tabGroup.tabs[
            this.selectedIndex
          ].alternatePageName;
        }
      } else {
        this.pageName = this.tabGroup.tabs[this.selectedIndex].pageName;
      }
    }
  }
  goToPage(pageName) {
    if (this.report && this.report.iframe && this.report.iframe.contentWindow) {
      this.report.getPages().then((pages) => {
        pages.forEach((page) => {
          if (page.displayName === pageName) {
            page
              .setActive()
              .then(() => {
                console.log(`Active page has been set to ${page.displayName}`);
                this.analyticsService.postAcknowledgeTabChangeCommand('Home Page', page.displayName, this.reportConfig.uniqueId);
              })
              .catch((error) => {
                console.log(
                  `Error: ${error}. Can't set page to ${page.displayName}`
                );
              });
          }
        });
      });
    }
  }

  private isFeatureEnabled(tabId: string) {
    if (!this.tabGroup) {
      return true;
    }
    if (this.tabGroup) {
      for (const tab of this.tabGroup.tabs) {
        if (tab.id === tabId) {
          if (tab.features.length === 0) {
            return true;
          }
          for (const feature of tab.features) {
            if (this.features[feature]) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }
  getReportConfig() {
    this.loadingAnimation();
    this.dashboardService.getAnalyticsReportToken(this.reportType, 'Home Page').pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        (payload: any) => {
          if (payload) {
            this.dashboardStore.dispatch(new ResetAnalyticsReportSuccess(payload));
          } else {
            this.failureResponse = true;
            this.failureResponse$ = of(this.failureResponse);
            this.dataLoaded = false;
            console.error(
              `Failed to get ReportToken for type ${this.reportType}`
            );
            this.dashboardStore.dispatch(new ResetAnalyticsReportError((`Failed to get ReportToken for type ${this.reportType}`)));
          }
        },
        (err) => {
          this.failureResponse = true;
          this.failureResponse$ = of(this.failureResponse);
          this.dataLoaded = false;
          this.dashboardStore.dispatch(new ResetAnalyticsReportError((err)));
          console.error('Error in getting ReportToken for PowerBi', err);
        }
      );
  }

  resetReport(clearFilters = true) {
    this.dataLoaded = false;
    this.failureResponse = false;
    this.loadingAnimation();
    const command = new ResetVisualizerDataCommand(this.reportType);
    command.projectId = '[PROJECT_ID]';
    command.waitForResponse = false;
    if (clearFilters) {
      this.resetFiltersInReport();
    }
    this.dashboardStore.dispatch(new ResetAnalyticsReport(command));
  }
  private resetFiltersInReport() {
    if (this.user && this.user.productCode) {
      if (!this.user.productCode.includes("ITP-VISITOR")) {
        window.sessionStorage.removeItem('alertInfoId');
        this.alertInfoId = '';
        this.setAllFilter();
      }
    }
  }

  handleResetReport() {
    this.dashboardStore.pipe(select(resetAnalyticsStatus), take(1)).subscribe(isResetOngoing => {
      if (isResetOngoing === false) {
        this.getReportConfig();
      }
    });
    this.dashboardStore.pipe(select(resetAnalyticsSuccess), takeUntil(this.ngUnsubscribe$)).subscribe(payload => {
      if (payload) {
        console.log('Reset visualizer Data command complete');
        this.dataLoaded = true;
        this.failureResponse = false;
        this.setConfig(payload.reportToken);
        this.isEditable = payload.isEditable;
        this.isDefaultReport = payload.isDefaultReport;
        if (payload.filters) {
          this.reportFilters = payload.filters;
        }
        const hasReportUpdate = payload.hasReportUpdate;
        if (!hasReportUpdate) {
          this.displayReport(true);
        } else {
          this.dialogService.showYesNoDialog('Report Update Available', `There is an updated version of the report template available. <br /> Do you wish to update the report now?`)
            .pipe(take(1)).subscribe(state => {
              if (state.action === 'OK') {
                // this.fuseSplashScreenService.show();
                // const command = new PlatformCommand('UpdateReportTemplateCommand', 'VisualizerApi');
                // command.waitForResponse = true;
                // command.setValue('ReportType', this.reportType);
                // command.setValue('ReportConfigId', this.powerbiReportConfig.id);
                // this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandState => {
                //   const reportResponse = commandState.fieldValues['ReportResponse'];
                //   this.setConfig(reportResponse.reportToken);
                //   this.isEditable = reportResponse.isEditable;
                //   this.isDefaultReport = reportResponse.isDefaultReport;
                //   this.fuseSplashScreenService.hide();
                //   this.displayReport();
                // }, err => {
                //   this.fuseSplashScreenService.hide();
                //   this.displayReport();
                // });
                this.resetReport(false)
              } else {
                this.displayReport(true);
              }
            });
        }
      }
    });
    this.dashboardStore.pipe(select(resetAnalyticsError), takeUntil(this.ngUnsubscribe$)).subscribe(payload => {
      if (this.errorInit) {
        if (payload) {
          this.failureResponse = true;
          this.dataLoaded = false;
        }
      }
      this.errorInit = true;
    });

  }
  loadingAnimation() {
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
    }
    this.loadingPercentage.background = 'linear-gradient(to top, #337aee 0%, #eee 0%)';
    let timeInterval = 0;
    this.intervalTimer = setInterval(() => {
      timeInterval = timeInterval + 1.67;
      const timeIntervalString = timeInterval.toString() + '%';
      const backgroundGradient = `linear-gradient(to top, #337aee ${timeIntervalString}, #eee 0%`;
      this.loadingPercentage.background = backgroundGradient;
      // console.log(this.loadingPercentage.background);
      if (timeInterval >= 100 || this.dataLoaded || this.failureResponse) {
        clearInterval(this.intervalTimer);
      }
    }, 1000);
  }

  getAnalyticReportToolLinkCommand() {
    const platformCommand = new PlatformCommand("OpenDDTAnalyticReportCommand", Api.FileStoreApi);
    platformCommand.fieldValues['DefaultGraphId'] = 'default-due-date-graph';
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(commandResponse => {
      if (commandResponse.fieldValues['RedirectUrl']) {
        this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
      }      
      else if (commandResponse.fieldValues['RedirectCommand']) {
        this.commandService.executePlatformCommand(commandResponse.fieldValues['RedirectCommand']).pipe(take(1)).subscribe(commandResponse => {
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
        }) , error => {
          console.error('[DesktopEventDispatch] Failed command', error);
          this.fuseSplashScreenService.hide();
          };
        }
    }), error => {
      console.error('[DesktopEventDispatch] Failed command', error);
      this.fuseSplashScreenService.hide();
    };

  }

  getEntitiesAndTransactionsAnalyticReportToolLinkCommand(pageName: string) {
    const platformCommand = new PlatformCommand("OpenEntitiesAndTransactionAnalyticReportCommand", Api.FileStoreApi);
    platformCommand.fieldValues['DefaultGraphId'] = 'default-entity-transaction-graph';
    platformCommand.fieldValues['PageName'] = this.pageDictionary[pageName];
    platformCommand.projectId = '[PROJECT_ID]';
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(commandResponse => {
      if (commandResponse.fieldValues['RedirectUrl']) {
        this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
      }
      if (commandResponse.fieldValues['RedirectCommand']) {
        this.commandService.executePlatformCommand(commandResponse.fieldValues['RedirectCommand']).pipe(take(1)).subscribe(commandResponse => {
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
        }) , error => {
          console.error('[DesktopEventDispatch] Failed command', error);
          this.fuseSplashScreenService.hide();
          };
        }
    }), error => {
      console.error('[DesktopEventDispatch] Failed command', error);
      this.fuseSplashScreenService.hide();
    };

  }
}
